<template>
  <AdminBar :url_admin = "url_admin" :url_action="url_edit_produt" :title_action="title_action" />
  <ListingFilter
     :isActive="isActive"
     @toggleMenu="toggleMenu"
     @closeMenuFilter="closeMenuFilter"
     @filterRangerPrice="filterRangerPrice"
     @updateQueryFilter="updateQueryFilter"
     @clearQueryFilter="handleClearQueryFilter"
     @updateParams="updateParams"
     :menuFilter="dataFilters"
     :relevantFilter="relevantFilters"
     :lockedFilter="lockedFilter"
     :currentParams="currentParams"
     :productParams="productParams"
     :minMaxPrice="minMaxPrice"
     :currentTax="tax"
     :totalItems="formatNumber(totalProduct)"
     v-if="relevantFilters"
   />
 <div class="listing-page listing-content" :class="props.tax === 'shop' ? 'filter_shop' : 'filter_categorie'">
   <div v-if="isMobile" class="listing-actions custom_mobile" id="listing-actions">
     <!-- Product Count -->
     <div class="listing-action-product-count">
       {{ formatNumber(totalProduct) }} {{ totalProduct === 1 ? 'product' : 'products' }}
     </div>

     <!-- Sort By Section -->
     <div class="listing-action-sortBy" @click="toggleDropdown()">
       <span>Sort By : </span>
       <ListingSortBy
         @handleSortBy="handleSortBy"
         :isOpen="isOpen"
         :selected="productParams.orderby"
       />
     </div>

     <!-- Filter Button -->
     <div class="listing-action-filter" @click="toggleMenu">
       <span>Filter</span>
     </div>
   </div>  
  <div class="listing-banner" v-if="props.tax !== 'shop'">
    <BannerButton v-if="productTerm?.bannerMaster && productTerm?.bannerMaster.enable_banner" padding_bottom="0" :isListing="true" :bannerDataProp="productTerm?.bannerMaster" />
    <Heading level="1" v-else style="text-align: center;padding-top:60px" class="master-section">{{ htmlSpecialcharsDecode(productTerm?.name) }}</Heading>
   </div>
   <div class="listing-banner" v-else>
    <!-- banner shop -->
    <BannerButton v-if="data_banner && props.tax === 'shop'" :bannerDataProp="data_banner" />
    <Heading v-if="!data_banner || (Array.isArray(data_banner) && data_banner.length === 0) || (typeof data_banner === 'object' && Object.keys(data_banner).length === 0)" level="1"  style="text-align: center;padding-top:60px" class="master-section">Shop</Heading>
   </div>
   <div class="listing-content">
     <ListingJumpLink  :productTerm="productTerm" v-if="props.tax !== 'shop' && !(['collection', 'occasions', 'price_range', 'metal_color', 'recipients', 'shop'].includes(props.tax))"/>

     <ProductJumplinkVarify
        v-if="(['collection', 'occasions', 'price_range', 'metal_color', 'recipients', 'shop'].includes(props.tax)) && dataShortFilters"
        :menuFilter="dataShortFilters"
        @triggerQueryFilter="triggerQueryFilter"
      />

     <div v-if="!isMobile" class="listing-actions" id="listing-actions">
      <!-- Product Count -->
      <div class="listing-action-product-count">
        {{ formatNumber(totalProduct) }} {{ totalProduct === 1 ? 'product' : 'products' }}
      </div>

      <!-- Sort By Section -->
      <div class="listing-action-sortBy" @click="toggleDropdown()">
        <span>Sort By : </span>
        <ListingSortBy
          @handleSortBy="handleSortBy"
          :isOpen="isOpen"
          :selected="productParams.orderby"
        />
      </div>

      <!-- Filter Button -->
      <div class="listing-action-filter" @click="toggleMenu">
        <span>Filter</span>
      </div>
    </div>

    <!-- Mobile Product Count -->
    <div class="listing-action-product__count-mobile">
      <span>
        {{ formatNumber(totalProduct) }} {{ totalProduct === 1 ? 'product' : 'products' }}
      </span>
    </div>

    <!-- Product Listing Section -->
    <div class="listing-products">
       <div class="listing-products__row" v-for="(itemData, index) in productItems" :key="index">
        <div style="padding-bottom: 20px;"  class="listing-products__item">
          <template v-for="(item, itemIndex) in itemData" :key="item.id || `banner-${item.title}-${itemIndex}`">
            <div :class="[item?.size ? `listing-products__item--${item.size}` : 'listing-products__item--1']" v-if="item?.type !== 'banner_blocks'">
              <template v-if="item.hasAdvancedTax && item.hasAdvancedTax === 'yes' && item.swatchesVariation && Object.keys(item.swatchesVariation).length > 0">
                 <ProductItemCustomise
                      :item="item"
                      :xScale="1"
                      :yScale="1"
                      :customiseOption="customiseOption"
                      :customiseAtribute="item.customiseAtribute"
                      :swatchesVariation="item.swatchesVariation"
                      @click="onClickItem(item)"
                    />
              </template>
              <template v-else>
                    <ProductItem
                      :item="item"
                      :xScale="1"
                      :yScale="1"
                      @click="onClickItem(item)"
                      :active_slider="true"
                    />
              </template>
            </div>
            <div :class="[`listing-products__item--${item?.size}`]" v-else-if="item?.type === 'banner_blocks'">
              <ProductBlock
               :bannerDataProp="item"
              />
            </div>
          </template>
       </div>
       </div>
    </div>
    <span v-show="!isNaN(currentProductOnPage) && totalProduct > 0 && !isLoading"  class="listing-load-viewed" >
       You've viewed {{currentProductOnPage }} of {{ formatNumber(totalProduct) }} Products
     </span>
    <a @click="handleLoadMore()" class="listing-load-more" v-show="showLoadMore" v-if="!isLoading">LOAD MORE</a>
    <CategoryCarousel
    v-if="props.tax === 'collection'"
    padding="50px 0 0 0"
    catlocation="collection"
    />
    <CategoryCarousel
    v-if="props.tax === 'category'"
    padding="50px 0 0 0"
    catlocation="category"
    />
    <div class="listing-faq-section">
      <ListingQue v-if="productTerm?.seoDescription && productTerm?.seoDescription.enable" :description="productTerm?.seoDescription.description" :showReadMore="true"/>
      <Faqs v-if="productTerm?.faqs && productTerm?.faqs.enable" :data="productTerm?.faqs" :option_faqs="option_faqs" />
    </div>
  </div>
 </div>

 <ProductLoading v-if="isLoading" />
 <ScrollUpButton />

</template>

<script setup lang="ts">
import { useProductListing } from '~/composables/useProductListing';
import { useProductFilter } from '~/composables/useProductFilter';
import { useCustomGtm } from '~/composables/useEventTagManager';
import { formatNumber } from '~/utils/formatNumber';
import { ref,onMounted } from "vue";
import { useDebounceFn } from '@vueuse/core';
import ProductItem from "./ProductItem.vue";
import ListingFilter from "~/components/Listing/ListingFilter.vue";
import ListingSortBy from "~/components/Listing/ListingSort.vue";
import Faqs from "~/components/Product/SingleProduct/Faqs.vue"
import ListingQue from "~/components/Listing/ListingQue.vue";
import ProductBlock from '~/components/Product/ProductBlock.vue';
import ProductLoading from '~/components/Product/ProductLoading.vue';
import BannerButton from '~/components/Campaign/BannerButton.vue';
import ListingJumpLink from '../Listing/ListingJumpLink.vue';
import ProductJumplinkVarify from "~/components/Product/ProductJumplinkVarify.vue";
import CategoryCarousel from "~/components/Campaign/CategoryCarousel.vue";
import { useResizeFilter } from '@/assist/useResizeFilter';
import AdminBar from "~/components/Product/AdminBar.vue";
import useCategoryFilter from '@/composables/useCategoryFilter';
import ScrollUpButton from "@/components/ScrollUpButton.vue";

const url_admin = ref('');
const runtimeConfig = useRuntimeConfig();
const slug_term = ref('');
const url_edit_produt = ref('');
const title_action = ref('');
const route = useRoute()
const router = useRouter()
// const{handleScroll} = useResizeFilter();
const isMobile = ref(true);
const data_banner = ref();
const { $file } = useNuxtApp();
const userStore = useUserStore();
import useGenderFilter from '@/composables/useGenderFilter';

interface IResponseData {
    success: boolean;
    data: string;
}

const option_faqs = ref({
  "type" : 1,
  "style": {
    item: {
      background: 'transparent',
      hoverBackground: '',
      textColor: '#212529',
      hoverColor: '',
      fontSize: '15px'
    },
    icon: {
      background: '#000',
    },
    content: {
      background: 'rgba(157, 157, 157, 0.1)',
      textColor: '#212529',
      fontSize: '15px'
    }
  },
});

const props = defineProps({
 tax: {
   type: String,
   default: ''
 },
 terms: {
  type: Object,
  default: () => ({})
  }
});

const rangeValues = ref<any>({
  minPrice: 0,
  maxPrice: 0
});

const handleClearQueryFilter = (newLockedFilter = [], clearAll: boolean) => {
  clearQueryFilter(newLockedFilter, clearAll);
}

const {
  clearFilter,
  currentParams,
  lockedFilter,
  queryFilter,
  dataFilter,
  dataFilters,
  dataShortFilters,
  rawDataFilter,
  getProductFilter,
  clearQueryFilter,
  handleFilterPrice
} = useProductFilter(props.terms, props.tax);

const {
  isLoading,
  showLoadMore,
  totalProduct,
  productParams,
  productItems,
  customiseOption,
  productTerm,
  minMaxPrice,
  relevantFilters,
  currentProductOnPage,
  updateParams,
  getInitData,
  fetchProducts,
  handleSortBy,
  handleLoadMore,
  handleBackAndScroll
} = useProductListing(props.terms, props.tax);

const {
  trackViewItemList
} = useCustomGtm();

const setFilterParams = () => {
  if (props.terms) {
    const currentParms = currentParams.value;
    productParams.value = {
      ...productParams.value,
      ...currentParms
    };
    if (currentParms.hasOwnProperty('orderby')) {
      delete currentParms.orderby;
    }
    dataFilter.value = {
      ...dataFilter.value,
      ...currentParms
    };
  }
};
const fetchPosts = async () => {
  try {
    const { data: dataShop } = await useAsyncData(
          'master-template',
          async () => {
              return $file.get('pages/shop.json', {
                headers: {
                  Authorization: `Bearer ${userStore.csrf}`,
                  'X-API-Server': userStore.csrf_server
                },
              });
          }
      )
    const response_data = dataShop.value as IResponseData;
    if ( response_data !== null && response_data.success) {
      data_banner.value = response_data.data?.banner;
    }
  } catch (e) {
      console.error(e);
  }
}
fetchPosts();
const position_filer = () => {
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  const screenWidth = window.innerWidth;
  const filter = document.querySelector('.listing-actions.custom_mobile');

  if (filter && screenWidth < 768) {
    if (scrollPosition > 0) {
      filter.classList.add('is_active_scroll');
    } else {
      filter.classList.remove('is_active_scroll');
    }
  }
};

await getProductFilter();
setFilterParams();
await getInitData();

// Debounce function to prevent duplicate API calls from ListingFilter + ProductJumplinkVarify
const triggerFetchProducts = useDebounceFn(() => {
  fetchProducts(productParams.value.page, false);
}, 150);

watch(
 [() => rangeValues.value, () => queryFilter.value],
 ([newRangeValues, newQueryFilter]) => {
  if( clearFilter.value ) {

    newRangeValues = {};
    rangeValues.value = '';

    clearFilter.value = false;
  }

  dataFilter.value = {...newQueryFilter,...newRangeValues};
  const newLockedFilter = {};
  Object.entries(newQueryFilter).forEach(([filterTax, filterItem]) => {
    newLockedFilter[filterTax] = JSON.stringify(filterItem);
  });

  productParams.value = {
    ...productParams.value,
    ...newLockedFilter
  };

  if( typeof productParams.value.default !== 'undefined' ) {
    productParams.value['default'] = productParams.value.default;
  }

  if( typeof dataFilter.value.maxPrice !== 'undefined' &&  dataFilter.value.maxPrice !== 0 ) {
    productParams.value.price = `${dataFilter.value.minPrice}@${dataFilter.value.maxPrice}`;
    if( clearFilter.value ) {
      productParams.value.price = '';}
  }

  productParams.value.page = 1;

  // Use debounced function instead of direct call
  triggerFetchProducts();
  // handleScroll();
},
 { deep: true }
);


onMounted( async() => {
  url_admin.value = runtimeConfig.public.BASE_URL + 'api/wp-admin/';
  slug_term.value = props.terms[props.tax][0];
  url_edit_produt.value = `${runtimeConfig.public.BASE_URL}api/wp-admin/?adminbar=${props.tax}&slug=${slug_term.value}`;
  title_action.value = 'Edit '+ props.tax;

  await handleBackAndScroll();
});

const isLoad = ref(false);
watch(() => props.terms, (newValue, oldValue) => {
  // handleScroll();
}, { deep: true });

onMounted(() => {
  // handleScroll();
  const screenWidth = window.innerWidth;
  if(screenWidth >= 768){
    isMobile.value = false;
  }
  window.addEventListener('scroll', position_filer);

  if (process.client) {
    setTimeout(() => {
      trackViewItemList(productItems.value[productItems.value.length - 1], props.tax);
      if (typeof window.lxt !== 'undefined' && productItems.value[productItems.value.length - 1]) {
        window.lxt('track', 'categories_viewed', productItems.value[productItems.value.length - 1]);
      }
    },300)
  }

  // window.addEventListener('scroll', handleScroll, { passive: true });
  // window.addEventListener('resize', handleScroll, { passive: true });
  // window.addEventListener('touchend', handleScroll, { passive: true });
  // window.addEventListener('touchmove', handleScroll, { passive: true });
});


onBeforeUnmount(() => {
  // handleScroll();
  // if (process.client) {
  //   handleScroll();
  //   window.removeEventListener('scroll', handleScroll);
  //   window.removeEventListener('resize', handleScroll);
  //   window.addEventListener('touchend', handleScroll);
  // }
});

const filterRangerPrice = (value:any) => {

  handleFilterPrice(`${value[0]}@${value[1]}`);
// handleFilterPrice(`${displayCustomPrice(value[0])}@${displayCustomPrice(value[1])}`);
// console.log('rangeValues.value', displayCustomPrice('33'), displayCustomPrice('1000'));
 rangeValues.value = {
   minPrice: value[0],
   maxPrice: value[1]
 };
 updateParams();
}
const updateQueryFilter = (value:any, tax: string, selected: any,selectedItem?: any) => {
  queryFilter.value = value;
  productParams.value.default = props.tax;
  const actualTax = tax === 'price_type' ? 'cost' : tax;
  if( typeof value[actualTax] === 'undefined' && typeof lockedFilter.value[actualTax] !== 'undefined' && lockedFilter.value[actualTax]?.includes(selectedItem)) {
    lockedFilter.value[actualTax] = lockedFilter.value[actualTax].filter(item => item !== selectedItem);
  }

  delete lockedFilter.value[actualTax];
  productParams.value[actualTax] = JSON.stringify(value[actualTax]) ?? '';
  updateParams()
}

const triggerQueryFilter = (slug: string, active: boolean) => {
  if( active ) {
    queryFilter.value = {
      ...queryFilter.value,
      "category": [slug]
    };

    productParams.value['category'] = JSON.stringify([slug]) ?? '';

    lockedFilter.value['category'] = [slug];
  }else {
    if ('category' in queryFilter.value) {
      const { category, ...remainingKeys } = queryFilter.value;
      queryFilter.value = remainingKeys;

    }

    if ('category' in productParams.value) {
      const { category, ...remainingKeys } = productParams.value;

      queryFilter.value = {...queryFilter.value};
      productParams.value = {
        category: '',
        ...remainingKeys
      };

      delete lockedFilter.value['category'];
    }
  }

  updateParams()
}

const closeMenuFilter = () => {
 isActive.value = false;
}

const isActive = ref(false);
const isOpen = ref(false);
const toggleDropdown = () => {
 isOpen.value = !isOpen.value;
};

const handleClickOutside = (event:Event) => {
 if (!event.target.closest('.dropdown')) {
   isOpen.value = false;
 }
};

// useCategoryFilter();
onMounted(() => {
  useGenderFilter();
  setTimeout(() => {
      useCategoryFilter();
    }, 500);
  document.addEventListener('click', handleClickOutside);
  //trackViewItemList(productItems.value[productItems.value.length - 1], props.tax);
  // if (typeof window.lxt !== 'undefined') {
  //   const pageTitle = productTerm?.bannerMaster.enable_banner ? htmlSpecialcharsDecode(productTerm?.name) : 'Shop';
  //   console.warn("lxt('track', 'categories_viewed', '" + pageTitle + "'");
  //   window.lxt('track', 'categories_viewed', pageTitle);
  // }
});

onUnmounted(() => {
 document.removeEventListener('click', handleClickOutside);
});

const toggleMenu = (event: Event) => {
  event.stopPropagation();
  isActive.value = !isActive.value;

  if (isActive.value) {
    document.body.style.overflowY = 'hidden';
  } else {
    document.body.style.overflowY = 'auto';
  }
};

const onClickItem = () => {
  if (process.client) {
    // pt list product to single back to list product
    // localStorage.setItem('curentPage', productParams.value.page);
    const scrollPosition = window.scrollY
    localStorage.setItem('scroll', scrollPosition);
    localStorage.setItem('pageUrl', window.location.href);
  }
}


const arrTax = {
  collection:'collection',
  category:'product-category',
  material:'material',
  metal_color:'metal-color',
  gemstone:'gemstone',
  price_range:'product-price-range',
  bridal:'product-bridal',
  recipients:'product-recipients',
  gold_type:'product-gold-type',
  occasions:'product-occasions',
  advanced:'product-advanced',
  gift:'gift',
  shop:'shop'
}

if (Array.isArray(route.params.slug) && typeof route.params.slug[0] !== 'undefined') {
  const slug = route.params.slug[0];

  if (typeof arrTax[props.tax as keyof typeof arrTax] !== "undefined") {
    const taxSlug = arrTax[props.tax as keyof typeof arrTax];

    useHead({
      link: [
        { rel: 'alternate', hreflang: 'x-default', href: `${runtimeConfig.public.BASE_URL}${taxSlug}/${slug}/` },
        { rel: 'alternate', hreflang: 'en-MY', href: `${runtimeConfig.public.BASE_URL}${taxSlug}/${slug}/` },
        { rel: 'alternate', hreflang: 'en-SG', href: `https://www.skjewellery.com/${taxSlug}/${slug}/` }
      ]
    });
  }



}




</script>
<style lang="css">
@import "@/assets/scss/components/listing/_listing.scss";

@media (min-width: 1024px) {
  .listing-page {
    .master-main-banner-text {
      @media (max-width: 1280px) {
        .heading h1 {
          font-size: 23px !important;
          line-height: 24px !important;
        }

        p {
          line-height: 17px !important;
        }

        &.text-right {
          margin-top: 0 !important;
        }

        a.btn-outline-dark {
          margin-top: 8px !important;
          padding-top: 7px !important;
        }
      }

      @media (min-width: 1281px) and (max-width: 1400px) {
        .heading h1 {
          font-size: 28px !important;
          line-height: 31px !important;
        }

        &.text-right {
          margin-top: 0 !important;
        }
      }

      @media (min-width: 1401px) and (max-width: 1820px) {
        .heading h1 {
          font-size: 30px !important;
          line-height: 35px !important;
        }

        &.text-right {
          right: 50px !important;
        }
      }
    }
  }
}
.filter_categorie {
  &.listing-page {
    .listing-content {
      .kts-filter__top {
        .list-cat {
          .cart-item {
            margin: 0;
          }
        }
      }
    }
  }
}

.listing-collections-custom {
  .box-cat-filter {
    .cart-item {
      width: auto !important;
      &.isactive {
        label {
          border: 1px solid #C60C46 !important;
        }
        span {
          color: #C60C46 !important;
        }
      }
      label {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #FFEEE6;
        padding: 8px 15px;
        column-gap: 10px;
        border: 1px solid transparent;
        transition: 0.4s;
        cursor: pointer;

      }
      input {
        display: none;
      }
      span {
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.6px;
        color: #000000;
      }
    }
  }
  .my-slider-progress {
    background: #ccc;
    display: none;
    height: 2px;
    margin-top: 10px;
    &.is-active {
      @media (max-width: 767.98px) {
        display: block;
      }
    }
    .my-slider-progress-bar {
      background: #c60c46;
      height: 100%;
      transition: width 0.4s ease;
    }
  }
}

.filter_shop {
  &.listing-page {
    .has-custom {
      padding-bottom: 0 !important;
    }
  }
}
</style>